<template>
  <div class="#">
    <BreadsCrums page="ourOrganization" previous="home" />
    <section class="services-v2">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="box-image garden-img-hv-scale garden-img-full-width">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1541160469/afrikeveil/projectv3-img.png"
                alt
              />
            </div>
          </div>
          <div class="col-md-8 col-sm-12">
            <div class="box-info">
              <h3 class="text-center">{{ $t("foundation") }}</h3>
              <p class="text-justify" v-html="aboutUs"></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="our-mission">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-md-offset-0">
            <div class="box">
              <div class="box-mission text-center">
                <div class="garden-title">
                  <div class="row">
                    <div class="col-md-4 col-sm-12 col-md-offset-4">
                      <div class="box-image garden-img-hv-scale garden-img-full-width">
                        <img
                          src="https://res.cloudinary.com/yanfomaweb/image/upload/v1587965454/afrikeveil/intro-slider.png"
                          alt
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <p class="ourMissionText">{{ $t("ourMissionText") }}</p>
                <span class="chairman">
                  --- DAMIEN SOMÉ - {{ $t("chairman") }} /
                  {{ $t("founder") }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="services-v3">
      <div class="row garden-row-none-padding">
        <div class="col-md-4 col-sm-12">
          <div class="box text-center">
            <div class="garden-img-full-width">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1577364369/afrikeveil/vision-2.png"
                alt
              />
            </div>
            <div class="text-default">
              <h3>Vision</h3>
            </div>
            <div class="text-hover">
              <div class="content">
                <div class="box-icon"></div>
                <h3>{{ $t("ourVision") }}</h3>
                <p>{{ $t("ourVisionText") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="box text-center">
            <div class="garden-img-full-width">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1577364460/afrikeveil/mission-2.png"
                alt
              />
            </div>
            <div class="text-default">
              <h3>Mission</h3>
            </div>
            <div class="text-hover">
              <div class="content">
                <h3>{{ $t("ourMission") }}</h3>
                <p class="text-justify">{{ $t("ourMissionText") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="box text-center">
            <div class="garden-img-full-width">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1577364226/afrikeveil/approach.png"
                alt
              />
            </div>
            <div class="text-default">
              <h3>{{ $t("approach") }}</h3>
            </div>
            <div class="text-hover">
              <div class="content content2">
                <h3>{{ $t("ourApproach") }}</h3>
                <p>{{ $t("ourApproachText") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Download
      :title="`${this.$i18n.t('brochureText')}`"
      link="https://res.cloudinary.com/yanfomaweb/image/upload/v1577005017/afrikeveil/Trifold-AFRIKEVEIL-2.pdf"
      :buttonTitle="`${this.$i18n.t('brochureButtonTitle')}`"
    />
  </div>
</template>

<script>
import Axios from "axios";
import APPURL from "../constant";
export default {
  watch: {
    $route() {
      this.getInfo();
    }
  },
  created() {
    document.title = this.$i18n.t("navBar.ourOrganization");
  },
  mounted() {
    this.getInfo();
  },
  computed: {
    aboutUs() {
      if (this.info[0]) {
        if (this.info[0].aboutFr) {
          return this.info[0].aboutFr;
        } else {
          return this.info[0].aboutUs;
        }
      }
      return "";
    }
  },
  data() {
    return {
      info: {}
    };
  },
  methods: {
    getInfo(url = APPURL.LINK + "settings/" + this.$i18n.locale) {
      Axios.get(url).then(response => {
        this.info = response.data.data.results;
        //console.log(this.info[0]);
      });
    }
  },
  name: "ourOrganization"
};
</script>

<style>
@media (max-width: 767px) {
  .our-mission {
    margin-top: -200px !important;
    padding-top: 50px;
  }
}

.services-v3 .box .text-default {
  background: none !important;
}
.text-hover {
  padding: 20px;
  color: white;
  text-align: justify;
}
.content h3 {
  padding: 30px;
  text-align: center;
  margin-bottom: 20px;
}
.services-v2 {
  background: #f2fdff;
  margin-top: -30px !important;
  padding-bottom: 70px !important;
}
.our-mission .box-mission {
  width: 100%;
  margin-top: 200px !important;
  margin-bottom: 50px !important;
  padding: 40px 65px 55px 65px;
  background: #ffffff;
  box-shadow: 0 0 54px rgba(0, 0, 0, 0.11);
  border-radius: 20px;
  position: relative;
  z-index: 1;
}
.box-info h3 {
  font-size: 40px !important;
  padding: 20px;
  font-weight: bolder;
}
.box-info p {
  line-height: 40px;
  padding-top: 20px;
  color: black !important;
  font-size: 17px !important;
}
.box-mission p {
  margin-bottom: 10px;
}
.chairman {
  font-weight: bold;
  text-transform: uppercase;
  font-style: italic;
}
@media (min-device-width: 320px) and (max-device-width: 480px) {
  .box-info h3 {
    font-size: 26px !important;
  }
  .text-hover .content2 {
    position: relative;
    z-index: 10000000;
    height: 100%;
    overflow: scroll;
    margin-top: 00px !important;
  }
  .services-v3 .col-md-4 {
    padding: 0px;
  }
  .ourMissionText {
    font-size: 17px;
    text-align: justify;
  }
}
@media (max-device-width: 320px) {
  .box-info h3 {
    font-size: 20px !important;
  }
  .text-hover .content2 {
    position: relative;
    z-index: 10000000;
    height: 100%;
    overflow: scroll;
    margin-top: 00px !important;
  }
  .services-v3 .col-md-4 {
    padding: 0px;
  }
  .ourMissionText {
    font-size: 15px;
    text-align: justify;
  }
}
</style>
